<template>
  <div class="steps-bar">
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      class="steps-bar__item"
      :class="{
        'steps-bar__item--active': step.id === active_id,
        'steps-bar__item--completed': is_completed(step.id),
        'steps-bar__item--disabled': !is_enabled(step.id),
        'steps-bar__item--clickable': allow_navigation && is_enabled(step.id),
      }"
      @click="handle_click(step)"
    >
      <vb-icon
        v-if="is_completed(step.id)"
        class="steps-bar__symbol"
        :name="'check'"
        :color="'ffffff'"
        :size="16"
      />
      <span v-else class="steps-bar__symbol">{{ index + 1 }}</span>
      <span class="steps-bar__label">{{ step.name }}</span>
      <span
        v-if="index !== steps.length - 1"
        :class="{
          'steps-bar__line': true,
          'steps-bar__line--completed': is_completed(step.id),
        }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "steps-bar",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    active_id: {
      type: String,
      default: "",
    },
    completed_ids: {
      type: Array,
      default: () => [],
    },
    enabled_ids: {
      type: Array,
      default: null,
    },
    allow_navigation: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    is_completed(id) {
      return this.completed_ids.indexOf(id) >= 0;
    },
    is_enabled(id) {
      if (!this.enabled_ids) return true;
      if (id === this.active_id) return true;
      return this.enabled_ids.indexOf(id) >= 0;
    },
    handle_click(step) {
      if (!this.allow_navigation) return;
      if (step.id === this.active_id) return;
      if (!this.is_enabled(step.id)) return;
      this.$emit("select", step.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.steps-bar {
  $this_step: &;
  background-color: $white;
  border-radius: 10px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: $grid-gutter-width/2;

  &__item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:last-child {
      width: min-content;
      justify-content: center;
      margin-right: $grid-gutter-width * 2;
    }

    &--clickable {
      cursor: pointer;
    }

    &--disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }

    &--active #{$this_step}-label {
      text-decoration: underline;
    }
  }

  &__symbol {
    background-color: var(--primary);
    border-radius: 50px;
    min-width: 25px;
    min-height: 25px;
    max-width: 25px;
    max-height: 25px;
    color: $white;
    font-size: $font-size-md;
    font-weight: $vb-font-weight-semibold;
    display: flex;
    align-items: center;
    justify-content: center;

    #{$this_step}-item--completed & {
      background-color: var(--success);
    }
  }

  &__label {
    font-weight: $vb-font-weight-semibold;
    margin-left: 10px;
  }

  &__line {
    margin-right: $grid-gutter-width/3;
    margin-left: $grid-gutter-width/3;
    min-height: 2.5px;
    flex-grow: 1;
    background-color: $gray-300;
    &--completed {
      background-color: var(--primary);
    }
  }
}
</style>
